import {ApiClientService, EntityApiService} from '@dofleini/security';

class ProcedureApiService extends EntityApiService {
  nextStepProcess = (params, config) => {
    return ApiClientService.patch(this.getPath(`/${params?._id}/next`), params, config);
  }

  backStepProcess = (params, config) => {
    return ApiClientService.patch(this.getPath(`/${params?._id}/back`), params, config);
  }

  searchProcessed = (params) => {
    return ApiClientService.post(this.getPath('/processed/search'), params);
  }

  downloadPDFCertificationAval = async (params) => {
    ApiClientService.pushDefaultHeader('Accept', 'application/pdf');
    const response = await ApiClientService.get(this.getPath(`/print/${params._id}`), {responseType: 'arraybuffer'});
    const type = response.headers['content-type'];
    // eslint-disable-next-line no-undef
    const blob = new Blob([response.data], {type: type, encoding: 'UTF-8'});
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${params.pdfName}.pdf`;
    link.click();
  }

  updateCheckListItem = ({proposalId, id, ...rest}) => {
    return ApiClientService.post(this.getPath(`/verify/${proposalId}/checklist/${id}`), rest);
  }

  count = (params) => {
    return ApiClientService.post(this.getPath('/count'), params);
  }

  assignResponsible = async (id, params, config) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.patch(this.getPath(`/${id}/assign-responsible`, params), params, config);
  }

  recuperateFromHistory = async (id, params, config) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.post(this.getPath(`/${id}/rollback-from-history`, params), params, config);
  }

  checkToCIBankProcess = async (id, params, config) => {
    return ApiClientService.patch(this.getPath(`/${id}/check-to-bank-ci`, params), params, config);
  }
  
  exportExcel = async (params) => {
    return ApiClientService.post(this.getPath('/export?format=excel'), params);
  }
}

export default new ProcedureApiService('/ms-auth/api/procedures');
